module.exports = __webpack_public_path__ + "static/media/Illus-Outpost_2.47ab9dc5.png";